import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=91db2ca0&"
import script from "./UserCard.vue?vue&type=script&lang=js&"
export * from "./UserCard.vue?vue&type=script&lang=js&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=91db2ca0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports